// src/components/Projects/Projects.jsx
import { Box, Typography, Container, Grid, Card, CardContent, CardMedia, Chip, Button } from '@mui/material';
import { motion } from 'framer-motion';

const projects = [
 {
  title: 'Retail Invoice Billing System',
  description: 'A comprehensive invoice billing and inventory management solution built with Java and Spring Boot. Features include invoice generation, inventory tracking, and sales reporting with a responsive user interface. Integrated with MySQL for reliable data storage and retrieval.',
  image: 'https://img.freepik.com/free-vector/invoice-concept-illustration_114360-2805.jpg',
  tags: ['Java', 'Spring Boot', 'MySQL', 'REST API', 'Hibernate'],
},
  {
   title: 'Hospital Management System',
  description: 'A comprehensive healthcare management solution built with React frontend and Java Spring Boot backend. Features include patient registration, appointment scheduling, doctor management, and electronic health records. Utilizes MongoDB for flexible data storage and Hibernate ORM for efficient database operations, all connected through secure RESTful APIs.',
  image: 'https://img.freepik.com/free-vector/hospital-building-concept-illustration_114360-8441.jpg',
  tags: ['React', 'Java', 'Spring Boot', 'MongoDB', 'REST API', 'Hibernate'],
},
  {
  title: 'BarberShop Mobile App',
  description: 'A comprehensive salon management mobile application built with React Native. Enables customers to book appointments, view services, and manage their profiles. Features include real-time booking updates via Firebase, secure payment processing, and an admin dashboard for business owners. The robust backend is powered by Spring Boot with MongoDB for flexible data storage.',
    image: 'https://img.freepik.com/free-vector/mobile-app-development-concept-illustration_114360-1354.jpg',
  tags: ['React Native', 'Firebase', 'Java', 'Spring Boot', 'REST API', 'MongoDB'],
},
  {
 
  title: 'TaskFlow: Task Management App',
  description: 'A productivity-focused mobile application built with React Native that helps users organize and prioritize their daily tasks. Features include task categorization, due date reminders, progress tracking, and cloud synchronization using Firebase. The intuitive UI/UX ensures seamless task management across multiple devices with real-time updates and offline support.',
  image: 'https://img.freepik.com/free-vector/task-management-abstract-concept-illustration_335657-2149.jpg',
  tags: ['React Native', 'Firebase', 'Redux', 'Firestore', 'Push Notifications'],
},
{
 
  title: 'Weather Application',
  description: 'A real-time weather application built with React that provides current weather conditions and forecasts. Features include location-based weather data, 5-day forecast, temperature unit conversion, and responsive design. The app fetches data from a RESTful API and displays it in an intuitive, user-friendly interface.',
  image: 'https://img.freepik.com/free-vector/weather-app-interface-concept-illustration_114360-1234.jpg',
  tags: ['React', 'REST API', 'Axios', 'Material-UI', 'Responsive Design'],
},
];

const Projects = () => {
  return (
    <Box id="projects" sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container maxWidth="lg" sx={{ textAlign: 'center', mb: 6 }}>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          style={{
            width: '150px',
            height: '150px',
            borderRadius: '50%',
            overflow: 'hidden',
            margin: '0 auto 20px',
            border: '4px solid #00bcd4',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
          }}
        >
          <img 
            src="https://via.placeholder.com/150" 
            alt="Profile"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </motion.div>
      </Container>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h2" component="h2" align="center" sx={{ mb: 6 }}>
            My Projects
          </Typography>
          
          <Grid container spacing={4}>
            {projects.map((project, index) => (
              <Grid item xs={12} md={6} lg={4} key={index}>
                <motion.div
                  whileHover={{ y: -10 }}
                  transition={{ duration: 0.3 }}
                >
                  <Card 
                    sx={{ 
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: 2,
                      overflow: 'hidden',
                      boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                      '&:hover': {
                        boxShadow: '0 15px 35px rgba(0,0,0,0.15)',
                      },
                    }}
                  >
                    <Box sx={{ p: 2, height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa' }}>
                      <CardMedia
                        component="img"
                        image={project.image}
                        alt={project.title}
                        sx={{
                          maxHeight: '100%',
                          maxWidth: '100%',
                          objectFit: 'contain',
                          objectPosition: 'center center',
                        }}
                      />
                    </Box>
                    <CardContent sx={{ flexGrow: 1, p: 3 }}>
                      <Typography variant="h6" component="h3" gutterBottom>
                        {project.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {project.description}
                      </Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 'auto' }}>
                        {project.tags.map((tag, tagIndex) => (
                          <Chip 
                            key={tagIndex}
                            label={tag}
                            size="small"
                            sx={{ 
                              fontSize: '0.7rem',
                              bgcolor: 'rgba(0, 188, 212, 0.1)',
                              color: 'primary.main',
                            }}
                          />
                        ))}
                      </Box>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Projects;